import * as React from 'react';


export default (props) => {
  const { onClick, label } = props;

  return (
    <a onClick={onClick} href="javascript:void(null)" className="btn btn--prim btn--md">
      {label}
    </a>
  );
};
